import { render, staticRenderFns } from "./TwTableScrollerList.vue?vue&type=template&id=2ea83eff&"
import script from "./TwTableScrollerList.vue?vue&type=script&lang=js&"
export * from "./TwTableScrollerList.vue?vue&type=script&lang=js&"
import style0 from "./TwTableScrollerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports